import {API_URL} from "../../../components/config/BaseUrl";

export const GET_QUEUES_URL = `${API_URL}/wificall/queue`;
export const ADD_QUEUE_URL = `${API_URL}/wificall/queue`;